import { memo } from 'react';
import { Layer, Source } from 'react-map-gl';

/* eslint-disable-next-line */
export interface ImageLayerProps {
  imageUrl: string;
  coordinates: number[][];
  id?: string;
  beforeId?: string;
}

export const ImageLayer = memo(function ImageLayer(props: ImageLayerProps) {
  const sourceId = props.id
    ? `image-data-${props.id}-${props.imageUrl}`
    : `image-data`;

  return (
    <Source
      coordinates={props.coordinates}
      id={props.id}
      key={sourceId}
      type="image"
      url={props.imageUrl}
    >
      <Layer beforeId={props.beforeId} id={props.id} type="raster" />
    </Source>
  );
});

export default ImageLayer;
